import React, { Component } from 'react'
import { Tab, Tabs } from 'react-bootstrap'
import { connect } from 'react-redux';
import NeedHelp from '../Elements/NeedHelp';
import SlackTab from './slackTab'
import { baseUrl, getInitialRoute, showAddAccountAlertNew, isAppleSafari } from '../../../../../../utils';
import SubmitFeedRequest from '../Elements/SubmitFeedRequest';
import { addUserAccount } from '../../../../../Authorization/SocialAuth/connectSocialAcc';
import { createFeedAction, getConnectedAccount } from '../../../../../../actions/addFeedActions';

const channel = isAppleSafari() ? window : new BroadcastChannel('connect');

class Slackfeed extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            keyword: '',
            error: false,
            selectedAcc: null,
            isChecked: false,
            filterType:'Channel',
            channelError :false,
        }

    }

    componentDidMount(){
        this.props.onFilterNameChange('by select channel name');
        this.setState({ filterType: 'Channel' });
        channel.addEventListener("message", this.readAuthenticationCode);
    }

    handleSelect = (e)=>{
        this.setState({selectedAcc:e,channelError:false});
    }

    handleInput = (e)=>{
        this.setState({keyword:e.target.value,error:false});
    }

    onAddAccount = () => {
       showAddAccountAlertNew({id:20,name:"slack"},"addFeed");
    }

    submit = () =>{
        const wallId = this.props.wallId;

        const {navigation,hideAddfeed} = this.props;
        const { filterType,keyword,selectedAcc } = this.state;

        this.setState({loading:true}); 
        if((filterType == "Channel")||(filterType == "ChannelKeyword" && keyword!='')){
            const obj = this.cookPostBody();

            createFeedAction(obj,20,(feedId)=>this.setState({loading:false},()=>{
                if(feedId){
                    hideAddfeed();
                    navigation(`/moderation/index/${wallId}`);
                }
            }));

        }else{
            if( selectedAcc != null){
                this.setState({error:true,loading:false});
            }else{
                this.setState({channelError:true,loading:false});
            }
        }
    }

    cookPostBody = () =>{
        const { wallId, connectedAcc } = this.props;
        const parentAcc = connectedAcc?.[0]?.ConnectedAccounts?.id ?? null;
        const { filterType, keyword, selectedAcc, isChecked } = this.state;
        return {
            wallId: wallId,
            networkId: 20,
            filter: this.getFilterType(),
            slackkeyword:filterType == "ChannelKeyword" ? keyword:'',
            connetedAccount:parentAcc, 
            feedType: 2, 
            account: selectedAcc,
            moderation:isChecked ? 1:0
        }
    }

    getFilterType = ()=>{
        return this.props.feedInfo[0].networkTab.reduce((acc,curr)=>{
            const filter = this.state.filterType === 'ChannelKeyword' ? 'Channel & Keyword' : this.state.filterType;
           if((curr.feedtype).toLowerCase()===(filter).toLowerCase()){
            return curr.filter;
           }
           return acc;
        },this.props.feedInfo[0].networkTab[0].filter);
      }

      readAuthenticationCode = (event) => {
        const response = JSON.parse(event.data);
        const { data, networkId, type } = response;
        if (type == "addFeed") {
            addUserAccount(networkId, data, () => this.props.getConnectedAccount(20), localStorage.getItem('ownerId'));
        }
    }


    componentWillUnmount() {
        channel.removeEventListener("message", this.readAuthenticationCode);
    }


    render() {
        const { connectedAcc, onBack } = this.props;
        const { isChecked,keyword,error,loading,selectedAcc,channelError, filterType } = this.state;
        const connectedAccounts = connectedAcc?.[0]?.ConnectedAccounts ?? [];
        return (
            <div className="row">
                <div className="col-md-12">
                    <div className="form-body">
                        <div className="tabbable-tabdrop newRadio d-flex align-items-center justify-content-between flex-wrap feeds_details personalizePopup">
                            {!(connectedAcc && connectedAcc.length>0) ?
                                <Tabs activeKey={'slack_acc_conn'} id="CreateFeedTab_slack_ac" className="nav-tabs-line nav-tabs-bold w-100 tabDrop mb-3">
                                    <Tab eventKey="slack_acc_conn" className="nav-link p-0 ms-0 mt-2" title="Connect Account">
                                        <div className="form-group">
                                            <div className="form-group text-center mt-7 mb-6">
                                                <div className="py-3">
                                                    <a className="btn btn-outline-gray btn-lg w-auto btn-clean d-inline-flex align-items-center btn-lg px-3">
                                                        <span className="symbol symbol-25 me-3">
                                                            <img src={`${baseUrl('social-icons/slack.svg')}`} alt="" />
                                                        </span>
                                                        <span className="text-dark-50 font-weight-bolder font-size-base" onClick={() => this.onAddAccount()}>Connect Slack</span>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </Tab>
                                </Tabs>
                                :
                                <Tabs activeKey={filterType} id="CreateFeedTab_slack" className="nav-tabs-line nav-tabs-bold w-100 tabDrop mb-3" onSelect={e => { this.setState((prev) => ({ ...prev, filterType: e }))}}>
                                    <Tab eventKey="Channel" className="nav-link p-0 ms-0 mt-2" title={<span>Channel</span>}>
                                        <SlackTab accounts={connectedAccounts.child} tab={'Channel'} checkBox={isChecked} setCheckBox={()=>this.setState({...this.state,isChecked:!isChecked})} error={error} keyword={keyword} handleInput={this.handleInput} onSelect={this.handleSelect} selectAccount={selectedAcc} channelError={channelError}/>
                                    </Tab>
                                    <Tab eventKey="ChannelKeyword" className="nav-link p-0 ms-0 mt-2" title={<span>Channel & Keyword</span>}>
                                        <SlackTab accounts={connectedAccounts.child} tab={'ChannelKeyword'} checkBox={isChecked} setCheckBox={()=>this.setState({...this.state,isChecked:!isChecked})} error={error} keyword={keyword} handleInput={this.handleInput} onSelect={this.handleSelect} selectAccount={selectedAcc} channelError={channelError}/>
                                    </Tab>
                                </Tabs>
                            }
                            <div className="form-actions w-100">
                                <div className="f-between flex-wrap border-top pt-3 mt-4">
                                    
                                    {getInitialRoute() === 'widget' ? 
                                    <NeedHelp text={'Need help in adding feeds?'} videoUrl={'https://player.vimeo.com/video/497245578'} supportLink={'https://taggbox.com/support/how-to-add-feeds-to-taggbox-widget/'} />
                                    :
                                    <NeedHelp text={'Need help in adding feeds?'} videoUrl={'https://vimeo.com/537142427/55c5d22e63'} supportLink={''} />
                                    }
                                    <SubmitFeedRequest onSubmit={this.submit} onBack={onBack} loading={loading} hideBtn={!(connectedAcc && connectedAcc.length>0)}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        )
    }
}

const mapStateToProps = (state) => {
    return {
        connectedAcc: state.addFeedReducer.connectedAcc,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        getConnectedAccount: (networkId) => dispatch(getConnectedAccount(networkId)),
    };
  };

export default connect(mapStateToProps, mapDispatchToProps)(Slackfeed)